import Image from './Image';
import type { ImageFormat, ImageProps } from './types';

export default Image;
export type { ImageFormat, ImageProps };
